module.exports = __webpack_public_path__ + "img/assistente_virtual.5b82787f.png";